import { render, staticRenderFns } from "./LoginSetPassword.vue?vue&type=template&id=9b3040b8&"
import script from "./LoginSetPassword.vue?vue&type=script&lang=js&"
export * from "./LoginSetPassword.vue?vue&type=script&lang=js&"
import style0 from "./LoginSetPassword.vue?vue&type=style&index=0&id=9b3040b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QInput,QCardActions,QBtn});
